module.exports = __webpack_public_path__ + "static/media/event2.c871bdd7.jpeg";